import templateUrl from "./user-security-roles-editor.component.html";
import "./user-security-roles-editor.component.less";
import { IComponentOptions } from "angular";
import { EventEmitter } from "../../../../common/components/event-emitter";

const roleScope = {
    Global: "Global",
    Divisional: "Divisional",
    Organizational: "Organizational",
    EmploymentRecord: "EmploymentRecord",
    Hidden: "Hidden",
}

export const UserSecurityRolesEditorComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        user: "<",
        roles: "<",
        icdOffices: "<",
        divisions: "<",
        changeRoles: "&onChangeRoles"
    },
    controller: class {
        roleScope = roleScope;
        virtualLimit = 25;
        userRoles: any;
        changeRoles: EventEmitter<{roles: any, rolesAtDivisions: any, rolesAtOffices: any }>;
        roles: any;
        user: any;
        divisions: any;
        icdOffices: any;
        constructor() {
            'ngInject';
        }

        $onChanges(changesObj) {
            if (changesObj.roles || changesObj.user) {
                this.partitionUserRoles();
                this.sortUserRoles();
            }
        }

        onChangeRoles() {
            const roles = !this.userRoles[roleScope.Global] ? [] :
                this.userRoles[roleScope.Global].filter(p => p.IsInRole).map(p => p.RoleID);
            const rolesAtDivisions = !this.userRoles[roleScope.Divisional] ? [] :
                this.userRoles[roleScope.Divisional].reduce((rolesAtDivisions, role) => {
                    return rolesAtDivisions.concat(role.Divisions.map(p => ({
                        RoleID: role.RoleID,
                        DivisionID: p.Id
                    })));
                }, []);
            const rolesAtOffices = !this.userRoles[roleScope.Organizational] ? [] :
                this.userRoles[roleScope.Organizational].reduce((rolesAtOffices, role) => {
                    return rolesAtOffices.concat(role.Offices.map(p => ({
                        RoleID: role.RoleID,
                        IcdOfficeID: p.Id
                    })));
                }, []);
            this.changeRoles({
                $event: {
                    roles,
                    rolesAtDivisions,
                    rolesAtOffices
                }
            });
        }

        partitionUserRoles() {
            const userRolePartition = this.roles.reduce((partitions, role) => {
                let scopedPartition = partitions[role.Scope];
                if (!scopedPartition) {
                    partitions[role.Scope] = scopedPartition = [];
                }
                const roleGrant = {
                    RoleID: role.RoleID,
                    Name: role.Name,
                    Description: role.Description,
                    GrantType: role.GrantType,
                    Scope: role.Scope,
                    Claims: role.Claims,
                    Divisions: null,
                    Offices: null,
                    IsInRole: false
                };
                switch (role.Scope) {
                    case roleScope.Global:
                        roleGrant.IsInRole = this.user.Roles.some(p => p === role.RoleID);
                        break;
                    case roleScope.Divisional:
                        roleGrant.Divisions = this.user.RolesAtDivisions.reduce((divisions, roleAtDivision) => {
                            if (roleAtDivision.RoleID === role.RoleID) {
                                const division = this.divisions.find(p => p.Id === roleAtDivision.DivisionID);
                                divisions.push(division);
                            }
                            return divisions;
                        }, []);
                        break;
                    case roleScope.Organizational:
                        roleGrant.Offices = this.user.RolesAtOffices.reduce((offices, roleAtOffice) => {
                            if (roleAtOffice.RoleID === role.RoleID) {
                                const office = this.icdOffices.find(p => p.Id === roleAtOffice.IcdOfficeID);
                                offices.push(office);
                            }
                            return offices;
                        }, []);
                        break;
                    default:
                        // There are other role scopes, but not relevant for this screen. EmploymentRecord
                        // is mainly intended for editing on the employment record screen, and Hidden
                        // is for internal use (eg, for identifying Self-sign-up)
                        break;
                }
                scopedPartition.push(roleGrant);
                return partitions;
            }, {});
            this.userRoles = userRolePartition;
        }

        sortUserRoles() {
            if (this.userRoles[roleScope.Global]) {
                // Sort granted roles first, then sort by name.
                this.userRoles[roleScope.Global].sort((a, b) => {
                    if (a.IsInRole && !b.IsInRole) {
                        return -1;
                    } else if (!a.IsInRole && b.IsInRole) {
                        return 1;
                    }
                    if (a.Name < b.Name) {
                        return -1;
                    } else if (a.Name > b.Name) {
                        return 1;
                    }
                    return 0;
                })
            }
            if (this.userRoles[roleScope.Divisional]) {
                // Sort by number of assigned divisions, then by name.
                this.userRoles[roleScope.Divisional].sort((a, b) => {
                    if (a.Divisions.length > b.Divisions.length) {
                        return -1;
                    } else if (!a.Divisions.length < b.Divisions.length) {
                        return 1;
                    }
                    if (a.Name < b.Name) {
                        return -1;
                    } else if (a.Name > b.Name) {
                        return 1;
                    }
                    return 0;
                })
            }
            if (this.userRoles[roleScope.Organizational]) {
                // Sort by number of assigned divisions, then by name.
                this.userRoles[roleScope.Organizational].sort((a, b) => {
                    if (a.Offices.length > b.Offices.length) {
                        return -1;
                    } else if (!a.Offices.length < b.Offices.length) {
                        return 1;
                    }
                    if (a.Name < b.Name) {
                        return -1;
                    } else if (a.Name > b.Name) {
                        return 1;
                    }
                    return 0;
                })
            }
        }
    }
};
